import createApi from 'api/createApi';
import qs from 'query-string';

export const tags = {
	search: 'mw/search',
	search__csv: 'mw/search/csv',
};

export const searchApi = createApi({
	reducerPath: 'mw/searchApi',

	endpoints: (builder) => ({
		search: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/search',
				body,
			}),
			providesTags: [tags.search],
		}),
		searchCsv: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/search/csv',
				body,
				jsonType: true,
				waitFile: true,
				fullResp: true,
			}),
			providesTags: [tags.search__csv],
		}),
	}),
});

export const {
	search,
	searchCsv,
} = searchApi.endpoints;

export default searchApi;